export default __webpack_public_path__ + "static/media/linked_icon.6d58dbe8.png";